import InteractiveCatalog from '../../model/interactive/InteractiveCatalog';
import CanvasDimension from '../../model/interactive/CanvasDimension';

import InteractiveCatalogPageParser from './InteractiveCatalogPageParser';
import InteractiveCatalogIndexPageParser from './InteractiveCatalogIndexPageParser';
import ItemActionParser from './ItemActionParser';

export default class InteractiveCatalogParser {

    parse(data) {

        let interactiveCatalog = new InteractiveCatalog();

        let xml = $(data);
        let rootNode = xml.children().first();

        interactiveCatalog.catalogId = rootNode.children('ns2\\:catalogId').text();
        interactiveCatalog.title = rootNode.children('ns2\\:title').text();
        interactiveCatalog.navigationType = rootNode.children('ns2\\:navigationType').text();
        interactiveCatalog.firstPageLeft = (rootNode.children('ns2\\:firstPageLeft').text() == 'true');
        interactiveCatalog.horizontalSize = InteractiveCatalogParser.parseCanvasDimension(rootNode.children('ns2\\:horizontalSize'));
        interactiveCatalog.verticalSize = InteractiveCatalogParser.parseCanvasDimension(rootNode.children('ns2\\:verticalSize'));
        interactiveCatalog.universalSize = InteractiveCatalogParser.parseCanvasDimension(rootNode.children('ns2\\:universalSize'));

        rootNode.children('ns2\\:page').each((i, elem) => {
            interactiveCatalog.pages.push(InteractiveCatalogPageParser.parse($(elem)));
        });

        rootNode.children('ns2\\:indexPage').each((i, elem) => {
            interactiveCatalog.indexPages.push(InteractiveCatalogIndexPageParser.parse($(elem)));
        });

        interactiveCatalog.numPages = parseInt(rootNode.children('ns2\\:numPages').text());
        interactiveCatalog.indexNumPage = parseInt(rootNode.children('ns2\\:indexNumPage').text());
        interactiveCatalog.fullScreen = (rootNode.children('ns2\\:fullScreen').text() == 'true');
        interactiveCatalog.horizontalAlignmentType = rootNode.children('ns2\\:horizontalAlignmentType').text();

        rootNode.children('ns2\\:openAction').each((i, elem) => {
            interactiveCatalog.openActions.push(ItemActionParser.parse($(elem)));
        });

        interactiveCatalog.indexType = rootNode.children('ns2\\:indexType').text();
        interactiveCatalog.backgroundColor = rootNode.children('ns2\\:backgroundColor').text();

        return interactiveCatalog;
    }

    static parseCanvasDimension(node) {
        if (node.length > 0) {
            let canvasDimension = new CanvasDimension();
            canvasDimension.width = parseFloat(node.attr('width'));
            canvasDimension.height = parseFloat(node.attr('height'));
            return canvasDimension;
        }
        return undefined;
    }

}
